import React, { useState } from 'react';
import { register } from 'api';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, Input, InputPassword, Title, Button, Text } from 'ui';
import logo from '../assets/logo-white.png'
import queryString from 'query-string';

export default function(props) {

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState({});
  const [error, setError] = useState("");
  
  const loc = useLocation();
  const query = queryString.parse(loc.search);
  
  async function submit() {
    if(loading) {
      return;
    }
    if(!value.displayName) {
      setError("Enter your name.");
      return;
    }
    if(value.password !== value.password2) {
      setError("Your passwords don't match.");
      return;
    }
    if(!value.email) {
      setError("Please enter your email address.");
      return;
    }
    try {
      setLoading(true);
      
      // If there's a `plan` query variable, 
      // pass that into register
      value.planId = query.plan;
      await register(value);
    }
    catch(error) {
      setLoading(false);
      if(error.message) {
        setError(error.message);
        return;
      }
      // todo: report error to sentry, or similar
      setError("Something went wrong. Please try again.");
      return;
    }

    setLoading(false);
    history.replace('verify-email');
  }

  return (
    <div className="auth auth-register">
      <Form onSubmit={submit} value={value} onChange={setValue} className="auth-sidebar">
        <div className="auth-logo">
          <img src={logo} alt="Taptivate"/>
        </div>
        <Title white className="auth-title">Create an Account</Title>
        {error && <Text block color="red" bold small style={{paddingBottom:16}}>{error}</Text>}
        <Input name="displayName" label="Name" white className="auth-input"/>
        <Input name="email" label="Email Address" white className="auth-input"/>
        <InputPassword name="password" label="Password" white className="auth-input"/>
        <InputPassword name="password2" label="Confirm Password" white className="auth-input"/>
        <Button block small tertiary white className="auth-link" label="Already a member? Login here." to="login"/>
        <Button className="auth-button" white label={loading ? "Loading..." : "Get Started"} onClick={submit}/>
        <div style={{paddingTop:40}}>
          <Text block size={30} bold white>Taptivate communicates your brand's digital experience at the Unboxing Moment.</Text>
          <Text block size={30} bold orange>Activate Today.</Text>
        </div>
      </Form>
    </div>
  );
}